var _defs, _path, _line, _path2, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimCredito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.2 75.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-linecap: round;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linejoin: round;\n        stroke-width: 2.6px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,30.4c2.9,1.9,7.6,3.1,13,3.1,8.8,0,15.9-3.3,15.9-7.3M33.1,39.1c2.9,1.9,7.6,3.1,13,3.1,8.8,0,15.9-3.3,15.9-7.3M30.2,17.4c0,4,7.1,7.3,15.9,7.3s15.9-3.3,15.9-7.3M30.2,8.6c0,4,7.1,7.3,15.9,7.3s15.9-3.3,15.9-7.3-7.1-7.3-15.9-7.3-15.9,3.3-15.9,7.3ZM18.6,58.4c0,4,7.1,7.3,15.9,7.3s15.9-3.3,15.9-7.3M50.4,49.6v17.6c0,4-7.1,7.3-15.9,7.3s-15.9-3.3-15.9-7.3v-17.6M50.4,49.6c0,4-7.1,7.3-15.9,7.3s-15.9-3.3-15.9-7.3,7.1-7.3,15.9-7.3,15.9,3.3,15.9,7.3ZM33.1,29.1c0,4-7.1,7.3-15.9,7.3s-15.9-3.3-15.9-7.3,7.1-7.3,15.9-7.3,15.9,3.3,15.9,7.3ZM33.1,29.1c0,4-7.1,7.3-15.9,7.3s-15.9-3.3-15.9-7.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 30.2,
    y1: 24.4,
    x2: 30.2,
    y2: 7.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.4,50.5c6.7-.9,11.5-3.6,11.5-6.9M50.4,59.1c6.7-.9,11.5-3.6,11.5-6.9V8.9M1.3,29.1v26c0,4,7.1,7.2,15.9,7.2s1,0,1.4,0M1.3,46.4c0,4,7.1,7.2,15.9,7.2s1,0,1.4,0M29.1,42.5c2.5-1.3,4-2.9,4-4.8M1.3,37.8c0,4,7.1,7.2,15.9,7.2s3.7-.2,5.4-.4M50.4,49.3c0,4-7.1,7.2-15.9,7.2s-15.9-3.2-15.9-7.2,7.1-7.2,15.9-7.2,15.9,3.2,15.9,7.2Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 33.1,
    y1: 42.5,
    x2: 33.1,
    y2: 28.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimCredito);
export default __webpack_public_path__ + "static/media/dim-credito.3650ed4499766f3b4a621c1e336be22e.svg";
export { ForwardRef as ReactComponent };